import React from "react";
import { DropdownSingle, CheckboxInput, NumberInput, SwitchSingle } from "oolib";
import { StyledSidebarStack, StyledTemplateList, StyledFieldGrid } from "../../styled";
import { annotationKeys } from "../../utils/constants";
import { SidebarSection } from "../SidebarSection";
import { DescriptionText } from "../DescriptionText";

export const ControlsSidebar = ({
  activeCaseId,
  setActiveCaseId,
  testCases,
  activeCase,
  scopeOptionList,
  selectedScopeOptions,
  handleScopeToggle,
  annotationCounts,
  handleAnnotationCountChange,
  selfManaged,
  setSelfManaged,
  selfManagedOption,
  unifiedView,
  setUnifiedView,
  unifiedOption,
  debugMode,
  setDebugMode,
  forceV3,
  setForceV3,
  forceV3Option,
  showConnections,
  setShowConnections,
  connectionsOption,
}) => (
  <StyledSidebarStack>
    <SidebarSection
      title="Preset scenarios"
      description="Load curated combinations of templates, scopes, and tenant settings."
    >
      <DropdownSingle
        id="autogen-filter-test-case"
        value={activeCaseId}
        onChange={(id, nextValue) => {
          if (typeof nextValue === "string") {
            setActiveCaseId(nextValue);
          }
        }}
        options={testCases.map((testCase) => ({
          display: testCase.label,
          value: testCase.id,
        }))}
        placeholder="Pick a test case"
        saveValueAsString
      />
      {activeCase?.description ? (
        <DescriptionText>{activeCase.description}</DescriptionText>
      ) : null}
      <SwitchSingle
        id="debug-mode-switch"
        option={{ display: "Debug mode", value: true }}
        value={debugMode ? { display: "Debug mode", value: true } : undefined}
        onChange={(id, nextValue) => {
          setDebugMode(Boolean(nextValue));
        }}
        layoutStyle="style2"
      />
    </SidebarSection>

    <SidebarSection
      title="Filter scopes"
      description="Toggle document and annotation filters to watch pipeline differences."
    >
      <StyledTemplateList>
        {scopeOptionList.map((option) => (
          <CheckboxInput
            key={option.value}
            option={option}
            value={selectedScopeOptions}
            onClick={handleScopeToggle}
          />
        ))}
      </StyledTemplateList>
    </SidebarSection>

    <SidebarSection
      title="Tenant configuration"
      description="Control annotation hierarchy counts."
    >
      <StyledFieldGrid>
        {annotationKeys.map(({ key, label }) => (
          <NumberInput
            key={key}
            id={`annotation-count-${key}`}
            label={label}
            value={String(annotationCounts?.[key] ?? 0)}
            onChange={(id, val) => handleAnnotationCountChange(key, val)}
            min={0}
            placeholder="0"
          />
        ))}
      </StyledFieldGrid>
    </SidebarSection>

    <SidebarSection
      title="View options"
      description="Switch to unified mode, or open the visual dataset map."
    >
      <SwitchSingle
        id="unified-switch"
        option={unifiedOption}
        value={unifiedView ? unifiedOption : undefined}
        onChange={(id, nextValue) => setUnifiedView(Boolean(nextValue))}
        layoutStyle="style2"
      />
      <SwitchSingle
        id="connections-switch"
        option={connectionsOption}
        value={showConnections ? connectionsOption : undefined}
        onChange={(id, nextValue) => setShowConnections(Boolean(nextValue))}
        layoutStyle="style2"
      />
    </SidebarSection>
  </StyledSidebarStack>
);


